export const separarNumerosYPalabras = (
  entrada: string
): { numeros: string[]; palabras: string[] } => {
  const numeros = entrada.match(/\d+/g) || [];
  const palabras = entrada.match(/\p{L}+/gu) || [];

  return { numeros, palabras };
};

export const comprobarInclusion = (entrada: string, buscar: string[]): boolean => {
  return buscar.every((item) => entrada.includes(item));
};
